import { render, staticRenderFns } from "./RealStation.vue?vue&type=template&id=2e25f252&scoped=true"
import script from "./RealStation.vue?vue&type=script&lang=js"
export * from "./RealStation.vue?vue&type=script&lang=js"
import style0 from "./RealStation.vue?vue&type=style&index=0&id=2e25f252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e25f252",
  null
  
)

export default component.exports